import { Layout } from 'antd'
import PipelinesRouter from './PipelinesRouter'

export default function () {
  return (
    <Layout style={{ overflow: 'auto' }}>
      <PipelinesRouter />
    </Layout>
  )
}
